export const sleep = (ms: number) =>{
  return new Promise( async (resolve) =>{
    await setTimeout(()=>{
      resolve(true)
    }, ms)
  })
}

export const formatName = (name: string) => {
  name = name.toLowerCase()
    if(name.length>1)
    {
        name = name[0].toUpperCase() + name.substring(1)
    }
    else{
        name = name.toUpperCase()
    }
    return name
}

export const formatPhoneInput = (newTxt: string, dashPos: number[]) => {
    newTxt = newTxt.replace(/-/g, "")
    dashPos.forEach((value, indx) => {
      if (newTxt.length >= dashPos[indx]) {
        newTxt =
          newTxt.slice(0, dashPos[indx] - 1) +
          "-" +
          newTxt.slice(dashPos[indx] - 1)
      }
    })
    return newTxt;
  };

export const formatNumberCommaNoDecimals = (amount: any) => {
    if(amount=="")
    {
        return "";
    }
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
    return formatter.format(amount)
}

export const formatNumberComma = (amount: any) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    })
    return formatter.format(amount)
}

export const formatDollar = (amount: any) => {
    if(amount=="")
    {
        return "";
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    })
    return formatter.format(amount)
}

export const formatDollarDigits = (amount: any, digitsafter: any) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: digitsafter,
        maximumFractionDigits: digitsafter,
    })
    return formatter.format(amount)
}

export const formatDate = (dt: Date, stringformat: string) => {
    let strformat = ''
    for (let i = 0; i < stringformat.length; i++)
        strformat += char2num(dt, stringformat[i])
    return strformat
}

export const char2num = (dt: Date, c: string) => {
    switch (c) {
        case 'Y':
        return dt.getFullYear()
        case 'y':
        let y = dt.getFullYear()
        y = y % 100
        return y
        case 'M':
        let mth = dt.getMonth() + 1
        let sMth = mth.toString()
        if (mth < 10) {
            sMth = '0' + sMth
        }
        return sMth
        case 'd':
        let day = dt.getDate()
        let sDay = day.toString()
        if (day < 10) {
            sDay = '0' + sDay
        }
        return sDay
        case 'h':
        return dt.getHours()
        case 'm':
        return dt.getMinutes()
        case 's':
        return dt.getSeconds()
        case 'f':
        return dt.getMilliseconds()
        default:
        return c
    }
}

export function validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}

export function EmailHeader(){
  return `<div><img src="cid:logo@miamigo.ai" style="width:50px;"/><a style="font-size:30px; font-weight:700; color:#6fa56f;" href="https://miamigo.ai/">MiAmigo.ai</a></div><br>`
}

export const Emailfooter = (email: any) =>{
  return `<br><div style="display:flex; align-items:center;"><img src="cid:logo@64cents.com" style="width:30px;"/><a style="color:#6fa55f; font-size:24px; font-weight:700;" href="https://miamigo.ai">64cents.com</a></div>
  <br><br>
  <h3>If you wish to unsubscribe please click <a href="https://MiAmigo.ai/unsubscribe?unsubscribeemail=${email}">here</a></h3>
  
  `
}

export const getLine = (text: any, numberofchars: any) => {
    if(numberofchars>=text.length)
      return text;
  
    let words = text.split(' ');
    let usedchars = 0;
    let line = '';
    let idx = 0;
    while(usedchars< numberofchars && idx < words.length){
      line += words[idx] + " "
      usedchars = line.length;
      idx++;
    }
    return line;
  }

  export interface contractInfo {
    email: any
    buyerEmails?: any;
    mlsid: any
    owner?: any
    buyerNames: any
    lot?: any
    block?: any
    lotdescription?: any
    propertyCity: any
    propertyCounty: any
    cashOffer: any
    totaloffer: any
    earnestMoney: any
    optionMoney: any
    additionalEarnestMoney?: any
    optionPeriod: any
    titleCompanyAddress?: any
    titleCompanyName?: any
    timetoprovidesurvey: any
    isSellerPayingTitlePolicy: any
    isSellerPayingForSurvey: any
    receivedSellersDislosure: any
    daystoProvideSellersDislosure: any
    closingDate: any
    financingOffer: any
    isHOA: any
    brokerageFirm?: any
    brokerFirmLicence?: any
    agentName?: any
    agentLicense?: any
    agentEmail?: any
    agentPhone?: any
    brokerName?: any
    brokerLicence?: any
    brokerageCity?: any
    brokerageState?: any
    brokerageZip?: any
    brokerageStreet?: any
    brokerPhone?: any
    propertyAddress: any
    propertyID: any
    buyerconditions?: any
    homewarrantyDefault: any
    listagentname?: any
    listagentphone?: any
    listagentemail?: any
    listagentlicense?: any
    listbroker?: any
    listbrokerstreet?: any
    listbrokercitystatezip?: any
    listbrokerphone?: any
    bac?: any
  }
  
  export const getObjectData = (data: any[], key: string): any => {
    let valtemp = { label: key, value: '' }
    let val = data.find((x: any) => {
      return x.label == key
    })
    if (!val) {
      return valtemp
    }
    return val
  }
    
  export const House = '🏠'
  export const Townhouse = '🏘️'
  export const Multiunit = '🏘️'
  export const Condo = '🏢'
  export const Land = '🌲'
  export const School = '🏫'
  
  export const countiesList = [
    'County',
    'Collin County',
    'Dallas County',
    'Denton County',
    'Ellis County',
    'Hunt County',
    'Kaufman County',
    // 'Rockwall County',
    'Johnson County',
    // 'Parker County',
    'Tarrant County',
    // 'Wise County',
  ]
  export const StreetSuffixes = [
    "ALLEE",
    "ALLEY",
    "ALLY",
    "ALY",
    "ANEX",
    "ANNEX",
    "ANNX",
    "ANX",
    "ARC",
    "ARCADE",
    "AV",
    "AVE",
    "AVEN",
    "AVENU",
    "AVENUE",
    "AVN",
    "AVNUE",
    "BAYOO",
    "BAYOU",
    "BCH",
    "BEACH",
    "BEND",
    "BND",
    "BLF",
    "BLUF",
    "BLUFF",
    "BLUFFS",
    "BOT",
    "BTM",
    "BOTTM",
    "BOTTOM",
    "BLVD",
    "BOUL",
    "BOULEVARD",
    "BOULV",
    "BR",
    "BRNCH",
    "BRANCH",
    "BRDGE",
    "BRG",
    "BRIDGE",
    "BRK",
    "BROOK",
    "BROOKS",
    "BURG",
    "BURGS",
    "BYP",
    "BYPA",
    "BYPAS",
    "BYPASS",
    "BYPS",
    "CAMP",
    "CP",
    "CMP",
    "CANYN",
    "CANYON",
    "CNYN",
    "CAPE",
    "CPE",
    "CAUSEWAY",
    "CAUSWA",
    "CSWY",
    "CEN",
    "CENT",
    "CENTER",
    "CENTR",
    "CENTRE",
    "CNTER",
    "CNTR",
    "CTR",
    "CENTERS",
    "CIR",
    "CIRC",
    "CIRCL",
    "CIRCLE",
    "CRCL",
    "CRCLE",
    "CIRCLES",
    "CLF",
    "CLIFF",
    "CLFS",
    "CLIFFS",
    "CLB",
    "CLUB",
    "COMMON",
    "COMMONS",
    "COR",
    "CORNER",
    "CORNERS",
    "CORS",
    "COURSE",
    "CRSE",
    "COURT",
    "CT",
    "COURTS",
    "CTS",
    "COVE",
    "CV",
    "COVES",
    "CREEK",
    "CRK",
    "CRESCENT",
    "CRES",
    "CRSENT",
    "CRSNT",
    "CREST",
    "CROSSING",
    "CRSSNG",
    "XING",
    "CROSSROAD",
    "CROSSROADS",
    "CURVE",
    "DALE",
    "DL",
    "DAM",
    "DM",
    "DIV",
    "DIVIDE",
    "DV",
    "DVD",
    "DR",
    "DRIV",
    "DRIVE",
    "DRV",
    "DRIVES",
    "EST",
    "ESTATE",
    "ESTATES",
    "ESTS",
    "EXP",
    "EXPR",
    "EXPRESS",
    "EXPRESSWAY",
    "EXPW",
    "EXPY",
    "EXT",
    "EXTENSION",
    "EXTN",
    "EXTNSN",
    "EXTS",
    "FALL",
    "FALLS",
    "FLS",
    "FERRY",
    "FRRY",
    "FRY",
    "FIELD",
    "FLD",
    "FIELDS",
    "FLDS",
    "FLAT",
    "FLT",
    "FLATS",
    "FLTS",
    "FORD",
    "FRD",
    "FORDS",
    "FOREST",
    "FORESTS",
    "FRST",
    "FORG",
    "FORGE",
    "FRG",
    "FORGES",
    "FORK",
    "FRK",
    "FORKS",
    "FRKS",
    "FORT",
    "FRT",
    "FT",
    "FREEWAY",
    "FREEWY",
    "FRWAY",
    "FRWY",
    "FWY",
    "GARDEN",
    "GARDN",
    "GRDEN",
    "GRDN",
    "GARDENS",
    "GDNS",
    "GRDNS",
    "GATEWAY",
    "GATEWY",
    "GATWAY",
    "GTWAY",
    "GTWY",
    "GLEN",
    "GLN",
    "GLENS",
    "GREEN",
    "GRN",
    "GREENS",
    "GROV",
    "GROVE",
    "GRV",
    "GROVES",
    "HARB",
    "HARBOR",
    "HARBR",
    "HBR",
    "HRBOR",
    "HARBORS",
    "HAVEN",
    "HVN",
    "HT",
    "HTS",
    "HIGHWAY",
    "HIGHWY",
    "HIWAY",
    "HIWY",
    "HWAY",
    "HWY",
    // "HILL",
    // "HL",
    // "HILLS",
    "HLS",
    "HLLW",
    "HOLLOW",
    "HOLLOWS",
    "HOLW",
    "HOLWS",
    "INLT",
    "IS",
    "ISLAND",
    "ISLND",
    "ISLANDS",
    "ISLNDS",
    "ISS",
    "ISLE",
    "ISLES",
    "JCT",
    "JCTION",
    "JCTN",
    "JUNCTION",
    "JUNCTN",
    "JUNCTON",
    "JCTNS",
    "JCTS",
    "JUNCTIONS",
    "KEY",
    "KY",
    "KEYS",
    "KYS",
    "KNL",
    "KNOL",
    "KNOLL",
    "KNLS",
    "KNOLLS",
    "LK",
    "LAKE",
    "LKS",
    "LAKES",
    "LAND",
    "LANDING",
    "LNDG",
    "LNDNG",
    "LANE",
    "LN",
    "LGT",
    "LIGHT",
    "LIGHTS",
    "LF",
    "LOAF",
    "LCK",
    "LOCK",
    "LCKS",
    "LOCKS",
    "LDG",
    "LDGE",
    "LODG",
    "LODGE",
    "LOOP",
    "LOOPS",
    "MALL",
    "MNR",
    "MANOR",
    "MANORS",
    "MNRS",
    "MEADOW",
    "MDW",
    "MDWS",
    "MEADOWS",
    "MEDOWS",
    "MEWS",
    "MILL",
    "MILLS",
    "MISSN",
    "MSSN",
    "MOTORWAY",
    "MNT",
    "MT",
    "MOUNT",
    "MNTAIN",
    "MNTN",
    "MOUNTAIN",
    "MOUNTIN",
    "MTIN",
    "MTN",
    "MNTNS",
    "MOUNTAINS",
    "NCK",
    "NECK",
    "ORCH",
    "ORCHARD",
    "ORCHRD",
    "OVAL",
    "OVL",
    "OVERPASS",
    "PARK",
    "PRK",
    "PARKS",
    "PARKWAY",
    "PARKWY",
    "PKWAY",
    "PKWY",
    "PKY",
    "PARKWAYS",
    "PKWYS",
    "PASS",
    "PASSAGE",
    "PATH",
    "PATHS",
    "PIKE",
    "PIKES",
    "PINE",
    "PINES",
    "PNES",
    "PL",
    "PLAIN",
    "PLN",
    "PLAINS",
    "PLNS",
    "PLAZA",
    "PLZ",
    "PLZA",
    "POINT",
    "PT",
    "POINTS",
    "PTS",
    "PORT",
    "PRT",
    "PORTS",
    "PRTS",
    "PR",
    "PRAIRIE",
    "PRR",
    "RAD",
    "RADIAL",
    "RADIEL",
    "RADL",
    "RAMP",
    "RANCH",
    "RANCHES",
    "RNCH",
    "RNCHS",
    "RAPID",
    "RPD",
    "RAPIDS",
    "RPDS",
    "REST",
    "RST",
    "RDG",
    "RDGE",
    "RIDGE",
    "RDGS",
    "RIDGES",
    "RIV",
    "RIVER",
    "RVR",
    "RIVR",
    "RD",
    "ROAD",
    "ROADS",
    "RDS",
    "ROUTE",
    "ROW",
    "RUE",
    "RUN",
    "SHL",
    "SHOAL",
    "SHLS",
    "SHOALS",
    "SHOAR",
    "SHORE",
    "SHR",
    "SHOARS",
    "SHORES",
    "SHRS",
    "SKYWAY",
    "SPG",
    "SPNG",
    "SPRING",
    "SPRNG",
    "SPGS",
    "SPNGS",
    "SPRINGS",
    "SPRNGS",
    "SPUR",
    "SPURS",
    "SQ",
    "SQR",
    "SQRE",
    "SQU",
    "SQUARE",
    "SQRS",
    "SQUARES",
    "STA",
    "STATION",
    "STATN",
    "STN",
    "STRA",
    "STRAV",
    "STRAVEN",
    "STRAVENUE",
    "STRAVN",
    "STRVN",
    "STRVNUE",
    "STREAM",
    "STREME",
    "STRM",
    "STREET",
    "STRT",
    "ST",
    "STR",
    "STREETS",
    "SMT",
    "SUMIT",
    "SUMITT",
    "SUMMIT",
    "TER",
    "TERR",
    "TERRACE",
    "THROUGHWAY",
    "TRACE",
    "TRACES",
    "TRCE",
    "TRACK",
    "TRACKS",
    "TRAK",
    "TRK",
    "TRKS",
    "TRAFFICWAY",
    "TRAIL",
    "TRAILS",
    "TRL",
    "TRLS",
    "TRAILER",
    "TRLR",
    "TRLRS",
    "TUNEL",
    "TUNL",
    "TUNLS",
    "TUNNEL",
    "TUNNELS",
    "TUNNL",
    "TRNPK",
    "TURNPIKE",
    "TURNPK",
    "UNDERPASS",
    "UN",
    "UNION",
    "UNIONS",
    "VALLEY",
    "VALLY",
    "VLLY",
    "VLY",
    "VALLEYS",
    "VLYS",
    "VDCT",
    "VIA",
    "VIADCT",
    "VIADUCT",
    "VIEW",
    "VW",
    "VIEWS",
    "VWS",
    "VILL",
    "VILLAG",
    "VILLAGE",
    "VILLG",
    "VILLIAGE",
    "VLG",
    "VILLAGES",
    "VLGS",
    "VILLE",
    "VL",
    "VIS",
    "VIST",
    "VISTA",
    "VST",
    "VSTA",
    "WALK",
    "WALKS",
    "WALL",
    "WY",
    "WAY",
    "WAYS",
    "WELL",
    "WELLS",
    "WLS",
  ];
  
  export const removeStreetSuffix = (streetname: string) => {
    var name = streetname.toUpperCase()
    var namearr = streetname.toUpperCase().split(' ')
    let suffix = ''
    for (let i = 0; i < StreetSuffixes.length; i++) {
      for(let j=0; j<namearr.length; j++){
        if(namearr[j]==StreetSuffixes[i]){
          suffix = ' ' + StreetSuffixes[i]
          break
        }
      }
    }
    name = name.replace(suffix, '')
    return name.toLowerCase()
  }
  export const getRoomIdFromCaterogy = (category: any) => {
    switch (category){
      case "livingroom":
        return 1
      case "bedroom":
        return 2
      case "bathroom":
        return 3
      case "kitchen":
        return 4
      case "gameroom":
        return 5
      case "mediaroom":
        return 6
      case "frontyard":
        return 7
      case "backyard":
        return 8
      case "dining":
        return 9
      case "master":
        return 10
      case "unclear":
      case "other":
        return 0
      case "familyroom":
        return 11
      case "masterbath":
        return 12
      case "closet":
        return 13
      case "laundary":
        return 14
      case "foyer":
        return 15
      case "office":
        return 16
      case "pantry":
        return 17
      case "halfbath":
        return 18
      case "eatingarea":
        return 19
      default:
        return 1
    }
  }

  export const getCaterogyFromId = (id: any) => {
    switch (Number(id)){
      case 1:
        return "livingroom"
      case 2:
        return "bedroom"
      case 3:
        return "bathroom"
      case 4:
        return "kitchen"
      case 5:
        return "gameroom"
      case 6:
        return "mediaroom"
      case 7:
        return "frontyard"
      case 8:
        return "backyard"
      case 9:
        return "dining"
      case 10:
        return "master"
      case 11:
        return "familyroom"
      case 12:
        return "masterbath"
      case 13:
        return "closet"
      case 14:
        return "laundary"
      case 15:
        return "foyer"
      case 16:
        return "office"
      case 17:
        return "pantry"
      case 18:
        return "halfbath"
      case 19:
        return "eatingarea"
      case 0:
        return "other"
      default:
        return "livingroom"
    }
  }